import React from "react";
import PropTypes from "prop-types";
import { iconNames, iconRegistry } from "./iconsRegistry";

const getSizeValue = (size) => {
  if (typeof size === "number") {
    return size;
  }

  const sizes = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
  };

  return sizes[size] || size;
};

const UIIcon = ({
  name,
  icon: IconComponent,
  children,
  size,
  width,
  height,
  color,
  fill,
  stroke,
  strokeWidth,
  viewBox,
  title,
  selected,
  decorative,
  className,
  style,
  ...props
}) => {
  const ResolvedIcon = IconComponent || iconRegistry[name];
  const iconSize = getSizeValue(size);
  const resolvedWidth = width || iconSize;
  const resolvedHeight = height || iconSize;
  const resolvedColor = color || "currentColor";
  const ariaProps = decorative
    ? { "aria-hidden": true }
    : { role: "img", "aria-label": title || name };

  const sharedProps = {
    width: resolvedWidth,
    height: resolvedHeight,
    color: resolvedColor,
    fill,
    stroke,
    strokeWidth,
    className,
    style: {
      color: resolvedColor,
      flexShrink: 0,
      ...style,
    },
    selected,
    focusable: "false",
    ...ariaProps,
    ...props,
  };

  if (ResolvedIcon) {
    return <ResolvedIcon {...sharedProps} />;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      {...sharedProps}
    >
      {title && !decorative ? <title>{title}</title> : null}
      {children}
    </svg>
  );
};

UIIcon.propTypes = {
  name: PropTypes.oneOf(iconNames).isRequired,
  icon: PropTypes.elementType,
  children: PropTypes.node,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
    PropTypes.number,
    PropTypes.string,
  ]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewBox: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.bool,
  decorative: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

UIIcon.defaultProps = {
  icon: undefined,
  children: null,
  size: "md",
  width: undefined,
  height: undefined,
  color: undefined,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  viewBox: "0 0 24 24",
  title: "",
  selected: false,
  decorative: true,
  className: "",
  style: undefined,
};

UIIcon.icons = iconRegistry;
UIIcon.iconNames = iconNames;

export default UIIcon;
